import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MenuCareer = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("karir")}
      active={active}
      menu={[
        {
          text: t("BekerjadiBukopin"),
          link: "/career-work",
        },
        {
          text: t("LowonganPekerjaan"),
          link: "/career-jobs",
        },
      ]}
    />
  );
};
export default MenuCareer;
